export enum GeometricType {
  Point = "Point",
  Polygon = "Polygon",
}

export enum PlaceType {
  Building = "Building",
  Campus = "Campus",
  Floor = "Floor",
}

export interface Address {
  addressLine1: string | null;
  addressLine2: string | null;
  addressLine3: string | null;
  city: string | null;
  country: string | null;
  state: string | null;
  zipCode: string | null;
}

export interface Coordinate {
  latitude: number | null;
  longitude: number | null;
}

export interface Geometry {
  coordinates: Coordinate[] | null;
  type: GeometricType;
}

export interface Location {
  address: Address;
  geometry: Geometry;
}

export interface Place {
  location: Location | null;
  placeType: PlaceType | null;
  readonly systems: string[] | null;
  readonly hasDeployedSystems: boolean;
  readonly owner: string | null;
  id: string; // UUID
  href: string | null;
  name: string | null;
  createdDate: string | null; // DateString
  modifiedDate: string | null; // DateString
  description: string | null;
  tags: string[] | null;
  createdBy: string | null;
  modifiedBy: string | null;
}

export interface PlaceResponse {
  items: Place[];
  continuationToken: string;
}
